export default {
    
    messages: [
        { text: 'コアタイムは？', type: 'bot' },
        { text: '基本的にはないが，研究室に来ず相談もしなかったり，研究の進捗が芳しくない場合，厳しく問い詰められることも（卒業の可否はある程度自己責任）', type: 'teacher' },
        { text: 'ないので、自己管理能力が必要だと思います。', type: 'student' },

        { text: '教員とのコミュニケーションは？', type: 'bot' },
        { text: 'Slackが基本。対面で話したいときは，普段から研究室に来るようにする。', type: 'teacher' },
        { text: '嫌な顔をせずに親身に話してくれる。良い意味で圧をあまり感じないので気軽に話せると思います。', type: 'student' },

        { text: '先輩とのコミュニケーションは？', type: 'bot' },
        { text: '対面が基本。研究室の同じ部屋の先輩とは仲良くなる。', type: 'teacher' },
        { text: '上下関係厳しくないので、仲良く言いたいことを言い合える関係だと思います。', type: 'student' },

        { text: '研究室のイベントは？', type: 'bot' },
        { text: 'コロナ禍中はほぼ実施しなかったが，新入生歓迎会や忘年会，１日研修等企画すればなんでもOK。今年度は科学体験フェスティバルに出展した。', type: 'teacher' },
        { text: '少ないが、希望があれば今後増やしたいと思っています。', type: 'student' },

        { text: '企業との共同研究はしているか？', type: 'bot' },
        { text: '現在進行中（どこと提携しているかは秘密）', type: 'teacher' },
        { text: '研究活動に積極的な人にはチャンスがあると思います。', type: 'student' },

        { text: '就職に強い？', type: 'bot' },
        { text: '研究を頑張っていれば就職活動で不在にすることをとがめられることはない。OBの研究室訪問が毎年あるので，就職で困ったときはOBに相談', type: 'teacher' }, 
        { text: '人気有名企業に行っている先輩も多いので、就活のノウハウが溜まりつつあります。', type: 'student' },

        { text: '他学部との共同研究は？', type: 'bot' },
        { text: '医学部，機械，など複数進行中', type: 'teacher' },
        { text: '学生はいまのところ参加していないと思います。', type: 'student' },
        
        { text: '学会発表の頻度は？', type: 'bot' },
        { text: '学生次第。頑張れば年に数回，国内・国際学会で発表も可能', type: 'teacher' },
        { text: '研究をしっかりとしていれば定期的に声がかかります。しかし、無理矢理参加させられることはないです。', type: 'student' },
        
        { text: '研究室の設備は？', type: 'bot' },
        { text: '充実しているほうだと思う。今年度，大型設備（機械学習向け）を導入予定。必要な物があれば大体買ってもらえる（参考書籍，研究資料など）', type: 'teacher' },
        { text: '良いのでとくに困らない。家からも研究を進められるのは便利だと思います。', type: 'student' },       
        
        { text: '研究室のノルマ，作業量は？', type: 'bot' },
        { text: '厳しくないが，本人次第。学会発表に行く場合は原稿や発表資料を入念に添削されるので忙しくなる。修士論文や卒業論文は【同学年/先輩→指導教員】のように多段階チェックを実施し，入念に添削', type: 'teacher' },
        { text: '日頃からコツコツやっていれば苦ではないです。学会・卒論・修論の発表前は流石に忙しいです。', type: 'student' },

        { text: 'アルバイトなどはあるか？', type: 'bot' },
        { text: 'データ入力などのバイトがあるデータ整理は単純作業が多いが，報酬はそれなりにもらえるバイト', type: 'teacher' },
        { text: 'お小遣い程度に稼げます', type: 'student' },

        { text: '留年生も受け入れてもらえるか？', type: 'bot' },
        { text: 'もちろんです．やる気さえあれば入れます。ただし，研究はそれ相応の時間がかかるものがほとんどなので，うちの研究室で楽をすることは不可能だと考えてもらえればと思います。（授業が多くて研究できなかったけど卒業させてくれ，という甘い考えは捨ててください）', type: 'teacher' },
        
        { text: '大学院進学を考えているのですが，受け入れは可能でしょうか？', type: 'bot' },
        { text: '大歓迎です。そのまま博士後期課程まで進んでくれても可です。', type: 'teacher' },
        
        { text: 'バイトを入れてもいけるか？', type: 'bot' },
        { text: '当然，バイトを入れられないほど忙しい研究室ではないですが，バイトばかりしていてゼミを欠席したりしていると後で自分に返ってきます。', type: 'teacher' },
        { text: 'バイトしながらやっている人もいます。', type: 'student' },
        
        { text: 'まったく新しい研究をしたい', type: 'bot' },
        { text: 'どうぞやってください。最大限サポートはしますが，研究室にノウハウがない研究テーマだと，１年で結果が出せないかもしれません。それでもよければ新しいテーマを起ち上げてみてください。', type: 'teacher' },
        { text: '先生もかなりサポートしてくださるので、積極的に研究する人ならやっていけると思います。', type: 'student' },

      
      ],
}
